import type { ElementType } from 'react';
import { useLayout } from './context/layout/LayoutProvider';
import { AssemblyClassBuilder } from './builders/AssemblyClassBuilder';
import type { AssemblySettings, As } from './ModularTypes/AssemblySettings';
import './Assembly.css';

const Assembly = <T extends As>(props: AssemblySettings<T>) => {
  const { context } = useLayout();
  const { className, elementProps } = AssemblyClassBuilder.build(
    props,
    context.assembly || {},
  );
  const { children, as } = props;

  const Component = (as ?? 'div') as ElementType;

  return (
    <Component {...elementProps} className={className}>
      {children}
    </Component>
  );
};

export default Assembly;
